// Keep in sync with leaseend-api/services/temporaryInfos.ts YEAR_DIFF
const YEAR_DIFF = 8;
const MIN_ALLOWED_YEAR = new Date().getFullYear() - YEAR_DIFF;

export enum ERROR_TYPES {
  MISSING_DATA = 'Missing data',
  DECODING_SERVICE_ISSUE = 'Decoding Service Issue',
  INVALID_LICENSE_PLATE = 'Invalid license plate or state',
  OLD_CAR = 'Old Car',
  DEAL_EXISTS = 'Deal exists',
  IN_FLOW = 'In flow',
  RESTRICTED_CAR = 'Restricted Car',
}

export const OLD_CAR_ERROR_MSG =
  'We are typically unable to secure financing for vehicles from ' +
  `model year ${MIN_ALLOWED_YEAR} or older. Thank you.`;

export const UNABLE_TO_ASSIST_ERROR_MSG =
  'We cannot assist with lease buyouts for this vehicle type due to certain restrictions. ' +
  'Thank you.';

export const UNAVAILABLE_LIEHOLDER_ERROR_MSG =
  'Unfortunately, we are unable to assist customers with this specific lienholder. ' +
  'Thank you for understanding.';

export const UNSUPPORTED_LIENHOLDER_SELL_MSG =
  "Based on your lienholder, we can't help you sell your leased car, but we can help you buy it out.";

export const UNSUPPORTED_LIENHOLDER_SELL_SELECT_KEEP_MSG = `${UNSUPPORTED_LIENHOLDER_SELL_MSG} Select Keep My Car above to continue with a buyout.`;
